import {useLocalStorageState} from 'common/local_storage';
import {useCallback} from 'react';

export function usePremiumReminderDismissed(slug: string) {
  const key = `_iq_premium_reminder_dismissed_${slug}`;
  const [premiumReminderIsDismissed, dismissPremiumReminder] = useLocalStorageState(key, false);
  const dismiss = useCallback(() => dismissPremiumReminder(true), [dismissPremiumReminder]);
  return {premiumReminderIsDismissed, dismissPremiumReminder: dismiss} as const;
}
